export const LPTSX5000 = {
  DEFAULT_PORT: '10001',
};
